/**
 * @generated SignedSource<<1393265d4fc153b09006b0675b196371>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NounResolvedLinkFragment$data = {
  readonly address: string;
  readonly " $fragmentSpreads": FragmentRefs<"NounResolvedNameFragment">;
  readonly " $fragmentType": "NounResolvedLinkFragment";
};
export type NounResolvedLinkFragment$key = {
  readonly " $data"?: NounResolvedLinkFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"NounResolvedLinkFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NounResolvedLinkFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "address",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NounResolvedNameFragment"
    }
  ],
  "type": "ResolvedName",
  "abstractKey": null
};

(node as any).hash = "d7e9f4260ca3d31c812d68de364fd09c";

export default node;
